import { ButtonsGroup, Flex, Icon, SkeletonBox, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { BookkeepingItem as BookkeepingItemType } from '@features/reconciliation/types/bookkeepingItem'
import { BankLine, ReconciliationSuggestion } from '@modules-deprecated/bankReconciliation/types'

import { useBankTransactionDrawer } from '../../../../contexts/bankTransactionDrawerContext'
import { BookkeepingItem } from '../BookkeepingItem'
import { DifferenceSelector } from '../DifferenceSelector'
import { SuggestionAcceptButton } from '../SuggestionAcceptButton'
import { SuggestionIgnoreButton } from '../SuggestionIgnoreButton'
import * as Styled from './styles'

interface SuggestionItemProps {
  bankLine: BankLine | null
  suggestedBookkeepingItem?: BookkeepingItemType
  matchSuggestion?: ReconciliationSuggestion
  isLoading?: boolean
}

export const SuggestionItem = ({
  bankLine,
  suggestedBookkeepingItem,
  matchSuggestion,
  isLoading,
}: SuggestionItemProps): ReactElement => {
  const { t } = useTranslation()
  const { hasDifference, isCrossCurrency } = useBankTransactionDrawer()

  if (isLoading) {
    return <SkeletonBox fullWidth height={40} />
  }

  if (!suggestedBookkeepingItem || !matchSuggestion) {
    return <></>
  }

  return (
    <>
      <Styled.TitleWrapper>
        <Flex gap={Spacing.S16} alignItems="center">
          <Icon icon="sparkle" size="md" color="currentColor" />
          <Text weight="medium">{t('bank_transactions.drawer.suggestion_title')}</Text>
        </Flex>
      </Styled.TitleWrapper>
      <BookkeepingItem
        bookkeepingItem={suggestedBookkeepingItem}
        isOutlined
        footerContent={
          <>
            {hasDifference && !isCrossCurrency && <DifferenceSelector />}
            <ButtonsGroup centered fitToWidth>
              <SuggestionIgnoreButton matchSuggestion={matchSuggestion} />
              <SuggestionAcceptButton
                bankLine={bankLine}
                suggestedBookkeepingItem={suggestedBookkeepingItem}
                matchSuggestion={matchSuggestion}
              />
            </ButtonsGroup>
          </>
        }
      />
    </>
  )
}
